import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StoreState } from "./../types";

export interface Props {
  displayFields: StoreState.Query["displayFields"];
  columns: StoreState.Columns;
  filterOptions: SectionData[];
  onDrilldown: (filterDrilldown: string, newFields: string[]) => void;
}

interface SectionData {
  title: string;
  fields: string[];
}

function Sections({ displayFields, columns, onDrilldown, filterOptions }: Props) {
  // onDrilldown handles setting the state for subsection title
  // and passing field data for SubSectionFields.tsx to use
  const Section = filterOptions.map((sectionData: SectionData) => {
    const handleClick = () => {
      onDrilldown(sectionData.title, sectionData.fields);
    };

    const intersection = sectionData.fields.filter((value: string) => displayFields.includes(value));

    const filterField = intersection.map((value: string) => {
      if (columns != null) {
        const columnReferenceExists = columns && columns.hasOwnProperty(value);
        return columnReferenceExists ? columns[value].title : value;
      } else return undefined;
    });

    return (
      <li key={sectionData.title} className="printDark subsection-title">
        <button
          type="button"
          className="ds-c-button--transparent ds-u-text-align--left subsectionButton"
          onClick={handleClick}
        >
          {sectionData.title}
          <FontAwesomeIcon icon="angle-right" className="ds-u-float--right" />
        </button>
        <div className="printOnly">{filterField.join(", ")}</div>
      </li>
    );
  });

  return <div>{Section}</div>;
}
export default Sections;
